import { AxiosRequestConfig } from 'axios';

export const BOOTSTRAP_REQUEST_TIMEOUT_MS = 15000;

type RetriableAxiosRequestConfig = AxiosRequestConfig & {
	'axios-retry'?: {
		retries: number;
	};
	skipForbiddenRedirect?: boolean;
};

export const bootstrapRequestConfig: RetriableAxiosRequestConfig = {
	timeout: BOOTSTRAP_REQUEST_TIMEOUT_MS,
	'axios-retry': {
		retries: 0,
	},
	// AppRoutes shows its own error screen. /forbidden bootstraps again, so
	// redirecting there on a 403 would reload the page in a loop.
	skipForbiddenRedirect: true,
};
